import {
  CAMPAIGN_PLACEMENT_LINES,
  type CampaignPlacementBidKey,
} from '@/utils/workspaceCampaignPlacement';
import {
  EMPTY_PLACEMENT_METRICS,
  type PlacementDerivedMetrics,
} from '@/utils/workspacePlacementMetrics';

const PLACEMENT_PREFIX: Record<CampaignPlacementBidKey, string> = {
  top_of_search: 'tos',
  rest_of_search: 'ros',
  product_pages: 'pp',
};

function readNumber(bag: Record<string, unknown>, key: string): number | null {
  if (!(key in bag)) return null;
  const value = bag[key];
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function isMetricSnapshot(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

/** Map a `tos_` / `ros_` / `pp_` execution snapshot onto one placement card. */
export function placementCardMetrics(
  snapshot: Record<string, unknown> | null | undefined,
  placement: CampaignPlacementBidKey
): PlacementDerivedMetrics {
  const bag = snapshot ?? {};
  const prefix = PLACEMENT_PREFIX[placement];
  const read = (field: string) => readNumber(bag, `${prefix}_${field}`) ?? 0;
  const clicks = read('clicks');
  const cost = read('spend');
  return {
    ...EMPTY_PLACEMENT_METRICS,
    impressions: read('impressions'),
    clicks,
    cost,
    purchases30d: read('orders'),
    sales30d: read('sales'),
    ctr: read('ctr'),
    cpc: clicks > 0 ? cost / clicks : 0,
    cr: read('cvr'),
    acos: read('acos'),
    roas: read('roas'),
  };
}

export { CAMPAIGN_PLACEMENT_LINES };
